export type LanguageCode = 'en' | 'fr' | 'es' | 'de';

export type CurrencyCode = 'USD' | 'EUR';

export const LANGUAGES: { code: LanguageCode; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'de', label: 'Deutsch' },
];

export const CURRENCIES: { code: CurrencyCode; label: string }[] = [
  { code: 'USD', label: 'USD $' },
  { code: 'EUR', label: 'EUR €' },
];

export const DEFAULT_LANGUAGE: LanguageCode = 'en';
export const DEFAULT_CURRENCY: CurrencyCode = 'USD';

